<div class="editable-table-container mt-1">
  <div class="table-responsive-wrapper">
    <div class="table-scroll-container">
      <table class="table table-bordered" [ngClass]="customTableClass">
        <thead>
          <tr>
            <th *ngIf="showRowLabels" class="row-label-column">
              {{ rowColumnTitle || '' | translate }}
            </th>
            <th *ngFor="let column of columns" [style.width]="column.width">
              {{ column.label | translate }}
              <span *ngIf="column.required && !readOnly" class="text-danger"
                >*</span
              >
            </th>
            <th *ngIf="allowRowDeletion && !readOnly" style="width: 60px">
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          <!-- Loading State -->
          <ng-container *ngIf="loading">
            <tr *ngFor="let item of shimmerTableSize">
              <td *ngIf="showRowLabels">
                <div class="line loading-shimmer"></div>
              </td>
              <td *ngFor="let column of columns">
                <div class="line loading-shimmer"></div>
              </td>
              <td *ngIf="allowRowDeletion && !readOnly">
                <div class="line loading-shimmer"></div>
              </td>
            </tr>
          </ng-container>

          <ng-container *ngIf="!loading">
            <tr *ngFor="let row of rows; let rowIndex = index">
              <td *ngIf="showRowLabels" class="row-label-cell">
                {{ row.label | translate }}
              </td>

              <td *ngFor="let column of columns">
                <ng-container *ngIf="readOnly">
                  <span class="readonly-value">
                    {{
                      getCellDisplayValue(row.key, column.key, column)
                        | translate
                    }}
                  </span>
                </ng-container>

                <ng-container *ngIf="!readOnly">
                  <ng-container [ngSwitch]="column.type || 'text'">
                    <!-- Text Input -->
                    <ng-container *ngSwitchCase="'text'">
                      <input
                        type="text"
                        class="form-control form-control-sm editable-table-input"
                        [class.is-invalid]="isCellInvalid(row.key, column.key)"
                        [value]="getCellValue(row.key, column.key)"
                        [placeholder]="column.placeholder || ''"
                        [disabled]="isCellDisabled(row, column)"
                        (input)="onCellValueChange(row.key, column.key, $event)"
                        (blur)="markAsTouched()" />
                      <div
                        *ngIf="isCellInvalid(row.key, column.key)"
                        class="invalid-feedback">
                        {{ getCellErrorMessage(row.key, column.key) }}
                      </div>
                    </ng-container>

                    <!-- Number Input -->
                    <ng-container *ngSwitchCase="'number'">
                      <input
                        type="number"
                        class="form-control form-control-sm editable-table-input"
                        [class.is-invalid]="isCellInvalid(row.key, column.key)"
                        [value]="getCellValue(row.key, column.key)"
                        [placeholder]="column.placeholder || ''"
                        [min]="column.min"
                        [max]="column.max"
                        [disabled]="isCellDisabled(row, column)"
                        (input)="onCellValueChange(row.key, column.key, $event)"
                        (blur)="markAsTouched()" />
                      <div
                        *ngIf="isCellInvalid(row.key, column.key)"
                        class="invalid-feedback">
                        {{ getCellErrorMessage(row.key, column.key) }}
                      </div>
                    </ng-container>

                    <!-- Email Input -->
                    <ng-container *ngSwitchCase="'email'">
                      <input
                        type="email"
                        class="form-control form-control-sm editable-table-input"
                        [class.is-invalid]="isCellInvalid(row.key, column.key)"
                        [value]="getCellValue(row.key, column.key)"
                        [placeholder]="column.placeholder || ''"
                        [disabled]="isCellDisabled(row, column)"
                        (input)="onCellValueChange(row.key, column.key, $event)"
                        (blur)="markAsTouched()" />
                      <div
                        *ngIf="isCellInvalid(row.key, column.key)"
                        class="invalid-feedback">
                        {{ getCellErrorMessage(row.key, column.key) }}
                      </div>
                    </ng-container>

                    <!-- Date Input -->
                    <ng-container *ngSwitchCase="'date'">
                      <input
                        type="date"
                        class="form-control form-control-sm editable-table-input"
                        [class.is-invalid]="isCellInvalid(row.key, column.key)"
                        [value]="getCellValue(row.key, column.key)"
                        [disabled]="isCellDisabled(row, column)"
                        (input)="onCellValueChange(row.key, column.key, $event)"
                        (blur)="markAsTouched()" />
                      <div
                        *ngIf="isCellInvalid(row.key, column.key)"
                        class="invalid-feedback">
                        {{ getCellErrorMessage(row.key, column.key) }}
                      </div>
                    </ng-container>

                    <!-- Select Dropdown - Using irembogov-select -->
                    <ng-container *ngSwitchCase="'select'">
                      <div class="editable-table-select-wrapper">
                        <irembogov-select
                          [items]="column.options || []"
                          [bindLabel]="'label'"
                          [bindValue]="'value'"
                          [placeholder]="column.placeholder || 'Select'"
                          [disabled]="isCellDisabled(row, column)"
                          [customFormControl]="
                            getCellControl(row.key, column.key)!
                          "
                          [hideIcon]="true"
                          [customClass]="'editable-table-dropdown'"
                          (itemSelected)="
                            onDropdownCellValueChange(
                              row.key,
                              column.key,
                              $event
                            )
                          ">
                        </irembogov-select>
                        <div
                          *ngIf="isCellInvalid(row.key, column.key)"
                          class="invalid-feedback">
                          {{ getCellErrorMessage(row.key, column.key) }}
                        </div>
                      </div>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </td>

              <td *ngIf="allowRowDeletion && !readOnly" class="text-center">
                <button
                  type="button"
                  class="btn btn-sm btn-danger"
                  [disabled]="disabled"
                  (click)="deleteRow(row.key)">
                  <i class="icon-trash"></i>
                </button>
              </td>
            </tr>

            <tr *ngIf="rows.length === 0">
              <td
                [colSpan]="
                  columns.length +
                  (showRowLabels ? 1 : 0) +
                  (allowRowDeletion && !readOnly ? 1 : 0)
                "
                class="text-center text-muted py-4">
                {{ 'No rows available' | translate }}
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>

  <div *ngIf="allowRowAddition && !loading && !readOnly" class="mt-3">
    <button
      type="button"
      class="btn btn-sm btn-primary"
      [disabled]="disabled"
      (click)="addRow()">
      <i class="icon-plus"></i> {{ 'Add Row' | translate }}
    </button>
  </div>
</div>
